export default __webpack_public_path__ + "1825d5d15f6bb8945270e10d90c02016.svg";